export default "__VITE_ASSET__BBUHr0Dj__"